import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import RootState from 'typings/RootState'
import {
  selectEvent,
  selectConstrucProject,
  selectChecklistType,
} from 'features/qc/sitevisite/selector'
import {
  GetProjectsReq,
  CreatePlanReq,
  GetCheckListSVTypeByProjectReq,
} from 'features/qc/sitevisite/types'
import {
  getProjectForConstructPlan,
  createConstructPlanByQC,
  GetSVCheckListByProject,
} from 'features/qc/sitevisite/api'
import {
  userEmailSelector,
  serviceTokenSelector,
} from 'features/sensitive/sensitive.selector'
import { EventModal } from 'Components/Shared'
import RequestModal from '../RequestModal'

type FormProps = {
  onClose: () => void
  onSuccess: () => void
  visible?: boolean
}

type Props = ReduxProps & DispatchProps & FormProps

const CreateRequest = (props: Props) => {
  const {
    visible = false,
    onClose,
    onSuccess,
    projects,
    UserEmail,
    token,
    event,
    checklist,
  } = props

  const dispatch = useDispatch()
  const [enableModal, setEnableModal] = useState(false)
  const [projectCode, setProjectCode] = useState('')
  const [validateError, setValidateError] = useState('')
  const [checklistType, setChecklistType] = useState(0)

  useEffect(() => {
    setEnableModal(false)
    if (visible) {
      setChecklistType(0)
      getProjectData()
    }
  }, [visible])

  const getProjectData = () => {
    const req: GetProjectsReq = {
      UserEmail: UserEmail,
      status: 'Ready',
    }
    dispatch(getProjectForConstructPlan(token, req))
  }

  const getSVCheckListByProject = (projectCode: string) => {
    if (!projectCode) return
    setChecklistType(0)
    const data: GetCheckListSVTypeByProjectReq = {
      UserEmail: UserEmail,
      ProjectCode: projectCode,
    }
    dispatch(GetSVCheckListByProject(token, data))
  }

  const onChangeChecklistType = (checklistTypeID: number) => {
    setChecklistType(checklistTypeID)
  }

  const onSendRequest = (projectCode: string, date: any) => {
    if (checklistType === 0) {
      setValidateError('! กรุณาเลือกประเภท Checklist')
      return
    }
    setEnableModal(true)
    const req: CreatePlanReq = {
      UserEmail: UserEmail,
      ProjectCode: projectCode,
      AppointmentDate: date.format('YYYYMMDDHHmm'),
      ChecklistTypeID: checklistType,
    }
    dispatch(createConstructPlanByQC(token, req))
  }

  const successCallback = () => {
    setEnableModal(false)
    getProjectData()
    onSuccess()
  }

  return (
    <>
      <RequestModal
        onClose={onClose}
        onSendRequest={onSendRequest}
        projects={projects}
        visible={visible}
        onChangeProjectCode={getSVCheckListByProject}
        checklist={checklist}
        checklistType={checklistType}
        onChangeChecklistType={onChangeChecklistType}
        validateError={validateError}
        isComparison={true}
      />
      <EventModal
        event={[event]}
        enable={enableModal}
        successCalback={successCallback}
      />
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    projects: selectConstrucProject(state),
    event: selectEvent(state),
    token: serviceTokenSelector(state),
    UserEmail: userEmailSelector(state),
    checklist: selectChecklistType(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(CreateRequest)
